/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Day/view.blocks to change it.
import "DesignSystem/Fonts/Inter-300.css"
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import * as fromFlow from 'Simple/Flow'
import React from 'react'
import TimePickerPopup from 'DesignSystem/Calendar/TimePickerPopup/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'
import useIsMedia from 'Simple/hooks/useIsMedia'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Day({
  children,
  viewPath = "/DesignSystem/Calendar/Day",
  dayRef,
  isDisabled,
  onClick,
  isSelected,
  isShowingTimePicker,
  day = 10,
  time = "",
  onClickTime,
  slotsAvailability,
  parentViewPath
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isDisabled,isSelected})
  let isMedia = useIsMedia()
  return (<React.Fragment
>
<div
  data-testid="Day.Vertical"
  data-view-path={viewPath}
 ref={dayRef}
 className={`views-block ${styles.Vertical}`}
>
<button
  data-testid="Day.Vertical:1"
  data-view-path={viewPath}
 disabled={isDisabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bc-1-ioy': isSelected ? "rgba(0,147,201, 0.83)" : isHovered ? "rgba(0,147,201, 0.05)" : isShowingTimePicker ? "rgba(0,147,201, 0.83)" : "#ffffff",'--bc-2-ioy': isSelected ? "#0093c9" : isHovered ? "rgba(0,147,201, 0.83)" : isShowingTimePicker ? "#0093c9" : "#e5e5e5"}}
 className={`views-block ${styles.Vertical1}`}
>
<span
  data-testid="Day.Text"
  data-view-path={viewPath}
 style={{'--c-3-ioy': isSelected ? "white" : isHovered ? "rgba(0,147,201, 1)" : isShowingTimePicker ? "#ffffff" : "#323232"}}
 className={`views-text ${styles.Text}`}
>
{day}
</span>
<fromFlow.When is={isSelected}>
<span
  data-testid="Day.Text:1"
  data-view-path={viewPath}
 style={{'--c-3-ioy': isSelected ? "white" : isHovered ? "rgba(0,147,201, 1)" : "#323232",'--fs-4-ioy': isMedia.mobile ? "10px" : "14px"}}
 className={`views-text ${styles.Text1}`}
>
{time}
</span>
</fromFlow.When>
</button>
<fromFlow.When is={isShowingTimePicker}>
<TimePickerPopup
  viewPath={`${viewPath}/TimePickerPopup`}
 onClickTime={onClickTime}
 slotsAvailability={slotsAvailability}
 isSelected={isSelected}
 parentViewPath={parentViewPath}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}